export enum Mood {
  positive = 'green600',
  neutral = 'purple200',
  negative = 'ferrari200',
  none = 'default'
}
